// src/redux/appointment/appointment.selectors.js
import { createSelector } from 'reselect';

const selectAppointment = state => state.appointment || { appointments: [], loading: false, error: null };

export const selectAppointments = createSelector(
  [selectAppointment],
  appointment => appointment.appointments || []
);

export const selectAppointmentsLoading = createSelector(
  [selectAppointment],
  appointment => appointment.loading || false
);

export const selectAppointmentsError = createSelector(
  [selectAppointment],
  appointment => appointment.error || null
);